import React, {useMemo} from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import {SimpleGrid} from '@chakra-ui/react'
import DashboardIconTile from '../../../components/dashboard-icon-tile'
import InteractionStudioContent from '../../../components/interaction-studio/content'
import ContentSlot from '../../../components/content-slot'
import CSHeader from '../partials/header'
import useMultiSite from '../../../hooks/use-multi-site'
import {normalizeSfccLink} from '../../../utils/url'

const CustomerServiceDashboardPage = () => {
    const {locale} = useMultiSite()
    const {id, name, description, content} = useCustomerServicePageConfig()

    const contentLinks = useMemo(
        () =>
            content?.linklist.map((item, idx) => (
                <DashboardIconTile
                    key={idx}
                    to={normalizeSfccLink(locale.id, item.link)}
                    image={item.icon}
                    label={item.label}
                />
            )),
        [content, locale]
    )

    return (
        <CustomerServiceLayoutDefault pb={10}>
            <CSHeader headline={name} subline={description} />

            <SimpleGrid
                columns={{base: 2, md: Math.min(contentLinks.length, 3)}}
                paddingX={{base: 0, md: 2, xl: 8}}
                paddingBottom={12}
                rowGap={{base: 4, md: 6}}
                columnGap={{base: 4, md: 8}}
            >
                {contentLinks}
            </SimpleGrid>

            <InteractionStudioContent id="is-customer-service-middle">
                <ContentSlot
                    context="folder"
                    contextId={id}
                    disableSkeleton
                    slotId="customer-service-middle"
                    showError={false}
                    variant="cms"
                />
            </InteractionStudioContent>

            <InteractionStudioContent id="is-customer-service-bottom">
                <ContentSlot
                    context="folder"
                    contextId={id}
                    disableSkeleton
                    slotId="customer-service-bottom"
                    showError={false}
                    variant="cms"
                />
            </InteractionStudioContent>
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceDashboardPage
